import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import { FloatingContact } from './components/FloatingContact';
import { LangProvider } from './context/LangContext';
import ScrollToTop from './components/ScrollToTop';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import Seo from './components/Seo';
import Home from './pages/Home';
import WhoWeAre from './pages/WhoWeAre';
import DisordersWeTreat from './pages/DisordersWeTreat';
import BiologicalTherapy from './pages/BiologicalTherapy';
import SecondOpinion from './pages/SecondOpinion';
import OurLocations from './pages/OurLocations';
import Contact from './pages/Contact';
import InternationalPatients from './pages/InternationalPatients';
import LetterEditor from './pages/LetterEditor';
import VideoGallery from './pages/VideoGallery';
import PatientEducation from './pages/PatientEducation';
import Blogs from './pages/Blogs';
import BlogPost from './pages/BlogPost';
import FellowshipProgram from './pages/FellowshipProgram';
import Article from './pages/Article';
import AskRheumatologist from './pages/AskRheumatologist';
import CityPage from './pages/CityPage';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import AuthCallback from './pages/AuthCallback';

function usePageViews(location) {
  const lastPath = React.useRef(window.location.pathname + window.location.search);
  React.useEffect(() => {
    const path = location.pathname + location.search;
    if (lastPath.current === path) return;
    lastPath.current = path;
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: path,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location.pathname, location.search]);
}

function AppShell() {
  const location = useLocation();
  usePageViews(location);
  // Detect OAuth return synchronously during render (prevents race conditions)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <>
      <Seo pathname={location.pathname} />
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/who-we-are" element={<WhoWeAre />} />
          <Route path="/disorders-we-treat" element={<DisordersWeTreat />} />
          <Route path="/biological-therapy" element={<BiologicalTherapy />} />
          <Route path="/second-opinion" element={<SecondOpinion />} />
          <Route path="/our-locations" element={<OurLocations />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/international-patients" element={<InternationalPatients />} />
          <Route path="/video-gallery" element={<VideoGallery />} />
          <Route path="/patient-education" element={<PatientEducation />} />
          <Route path="/patient-education/:slug" element={<Article />} />
          <Route path="/ask" element={<AskRheumatologist />} />
          <Route path="/rheumatologist-in/:city" element={<CityPage />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:id" element={<BlogPost />} />
          <Route path="/fellowship-program" element={<FellowshipProgram />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/dashboard/letters/:id" element={<ProtectedRoute><LetterEditor /></ProtectedRoute>} />
        </Routes>
      </main>
      <Footer />
      <FloatingContact />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <LangProvider>
            <AppShell />
          </LangProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
